import React from "react";
import "./style.scss";

const levelColor = [
  "linear-gradient(54.17deg, #1793D7 35.22%, #65C8FF 100%)",
  "linear-gradient(61.78deg, #084C95 31.24%, #1793D7 88.69%)",
  "linear-gradient(54.17deg, #013369 35.22%, #0060C7 100%)",
];



const InvestorInfo = ({
  riskIndex,
  riskLevel,
  handleClick,
  containerStyle,
}) => {
  return (
    <div className="investor-info" style={containerStyle}>
      <div>
        <p style={{ fontSize: "12px" }}>Your risk profile</p>
        <span
        className="investor-info__level"
          style={{
            background: levelColor[riskIndex],

          }}
        >
          {riskLevel} investor
        </span>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        onClick={handleClick}
      >
        <path
          fillRule="evenodd"
          stroke="#0D629F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
          clipRule="evenodd"
        />
        <path
          stroke="#0D629F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="4"
          d="M12 17v-4"
        />
        <circle cx="12" cy="8" r="2" fill="#0D629F" />
      </svg>
    </div>
  );
};
export default InvestorInfo;
